import {
  RESET,
  SET_SUBMIT_ERROR,
  SET_SUBMITTING,
  SET_FILTERS,
  SET_PR_FILTERS,
  SET_SORT_ASCENDING,
  SET_SORTING_TYPE,
  SET_PR_SORTING_TYPE,
  SET_CR_SORTING_TYPE,
  SET_CR_SECTION,
  SET_CR_REPORT_IDS,
  SET_SURVEY_LANGUAGES,
  SET_DRIVERS_VIEWMODE,
  SET_STATEMENTS_VIEWMODE,
  SET_SHOW_YOUR_RESULTS
} from '../actions/survey'

const initialState = {
  submitError: null,
  submitting: false,
  filters: [],
  prFilters: [],
  sortingType: "byResult",
  crSortingType: "byResult",
  prSortingType: "byResultProgress",
  sortAscending: false,
  crSection: "overall",
  crReportIds: {
    themeId: null,
    driverId: null,
    statementId: null
  },
  surveyLanguages: ['en'],
  driversViewMode: "sparse",
  statementsViewMode: "sparse",
  showYourResults: false
};

const handleSetSubmitting = (state, {submitting}) => ({
  ...state,
  submitError: null, // reset submit error when changing state
  submitting,
});

const handleSetSubmitError = (state, {error}) => ({
  ...state,
  submitError: error,
  submitting: false,  // reset submitting state
});

const handleSetFilters = (state, {filters}) => ({
  ...state,
  filters
})

const handleSetPrFilters = (state, {prFilters}) => ({
  ...state,
  prFilters
})

const handleSetSortingType = (state, {sortingType}) => ({
  ...state,
  sortingType
})

const handleSetPrSortingType = (state, {prSortingType}) => ({
  ...state,
  prSortingType
})

const handleSetCrSortingType = (state, {crSortingType}) => ({
  ...state,
  crSortingType
})

const handleSetSortAscending = (state, {sortAscending}) => ({
  ...state,
  sortAscending
})

const handleSetCrSection = (state, {crSection}) => ({
  ...state,
  crSection
})

const handleSetCrReportIds = (state, { crReportIds }) => ({
  ...state,
  crReportIds
})

const handleSetSurveyLanguages = (state, {surveyLanguages}) => ({
  ...state,
  surveyLanguages
})

const handleSetDriversViewMode = (state, {driversViewMode}) => ({
  ...state,
  driversViewMode
})

const handleSetStatementsViewMode = (state, {statementsViewMode}) => ({
  ...state,
  statementsViewMode
})

const handleSetShowYourResults = (state, {showYourResults}) => ({
  ...state,
  showYourResults
})

export default (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case RESET:
      return initialState
    case SET_SUBMITTING:
      return handleSetSubmitting(state, payload)
    case SET_SUBMIT_ERROR:
      return handleSetSubmitError(state, payload)
    case SET_FILTERS:
      return handleSetFilters(state, payload)
    case SET_PR_FILTERS:
      return handleSetPrFilters(state, payload)
    case SET_SORTING_TYPE:
      return handleSetSortingType(state, payload)
    case SET_PR_SORTING_TYPE:
      return handleSetPrSortingType(state, payload)
    case SET_CR_SORTING_TYPE:
      return handleSetCrSortingType(state, payload)
    case SET_SORT_ASCENDING:
      return handleSetSortAscending(state, payload)
    case SET_CR_SECTION:
      return handleSetCrSection(state, payload)
    case SET_CR_REPORT_IDS:
      return handleSetCrReportIds(state, payload)
    case SET_SURVEY_LANGUAGES:
      return handleSetSurveyLanguages(state, payload);
    case SET_DRIVERS_VIEWMODE:
      return handleSetDriversViewMode(state, payload);
    case SET_STATEMENTS_VIEWMODE:
      return handleSetStatementsViewMode(state, payload);
    case SET_SHOW_YOUR_RESULTS:
      return handleSetShowYourResults(state, payload);
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/survey.js